import styled from 'styled-components';
import { MediaQuery } from 'octa-front-sdk';
import Color from 'octa-front-sdk/dist/enums/Color';
import FontSize from 'octa-front-sdk/dist/enums/FontSize';
import ModalButtonStyles from './ModalButton/styles';

const Logo = styled.img`
  width: 90px;
  min-width: 90px;
  height: 90px;
  align-self: flex-start;
  margin-right: 5px;
  border-radius: 10px;
  background-color: ${Color.White};
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.16),
    0px -1px 5px -5px rgba(0, 0, 0, 0.16);

  ${MediaQuery.BiggerThanSmall} {
    min-width: 160px;
    min-height: 160px;
    width: 160px;
    height: 160px;
  }

  ${MediaQuery.BiggerThanMedium} {
    margin-right: 20px;
  }
`;

const StatusLabel = styled.span<{ isOpen: boolean }>`
  font-size: ${FontSize.Small};
  color: ${({ isOpen }): string => (isOpen ? Color.Green500 : Color.Red500)};
  height: 40%;

  ${MediaQuery.BiggerThanSmall} {
    font-size: ${FontSize.Normal};
    height: unset;
  }
`;

const IconSvg = styled.img`
  width: 1.6rem;
  margin: 0 0.4rem;
`;

const LoyaltyContainer = styled.div`
  display: none;
  padding-left: 20px;

  & > p {
    margin-top: 0;

    &:first-of-type {
      font-size: ${FontSize.NormalX};
      display: flex;
      align-items: center;
    }
  }

  & > p,
  & > span {
    color: ${Color.Grey700};
  }

  & > div {
    display: flex;
    justify-content: space-between;
  }

  ${MediaQuery.BiggerThanMedium} {
    display: initial;
    border-left: 1px solid ${Color.Grey300};
  }
`;

const ModalButtonsWrapper = styled.div`
  height: 40%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${MediaQuery.BiggerThanMedium} {
    height: unset;
    flex-direction: row;
    margin-right: 20px;

    & > ${ModalButtonStyles.Container}:nth-of-type(2) {
      margin-left: 20px;
    }

    &:nth-of-type(2) > ${ModalButtonStyles.Container} {
      display: none;
    }
  }
`;

const ButtonsAndStatusContainer = styled.div<{ shouldAddTopMargin?: boolean }>`
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  ${MediaQuery.BiggerThanMedium} {
    order: 2;
    flex-basis: 100%;
    justify-content: flex-end;
    margin-top: ${({ shouldAddTopMargin }): string =>
      shouldAddTopMargin ? '60px' : '0'};
  }
`;

const Name = styled.h1`
  margin: 0 0 15px;
  font-size: ${FontSize.Big};
`;

const Description = styled.p`
  margin: 0 0 20px;
  color: ${Color.Grey600};
  line-height: 1.24rem;
  font-weight: lighter;
`;

const ContentColumn = styled.div`
  margin: 20px 0 15px;
  flex-basis: 100%;

  ${MediaQuery.SmallerThanMedium} {
    & > ${ButtonsAndStatusContainer} {
      display: none;
    }
  }

  ${MediaQuery.BiggerThanMedium} {
    margin-top: 0;
    order: 1;
    flex: 1;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 85px 20px 20px;
  position: relative;

  ${MediaQuery.BiggerThanMedium} {
    padding-top: 20px;
    background-color: ${Color.White};
    margin-bottom: 40px;
    border-radius: 10px;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.16),
      0px -1px 5px -5px rgba(0, 0, 0, 0.16);

    & > ${ButtonsAndStatusContainer} {
      display: none;
    }
  }
`;

const Background = styled.div<{ color: Color; headerUrl: string }>`
  background: ${({ headerUrl, color }): string =>
    headerUrl ? `url(${headerUrl}) center center no-repeat` : `${color}`};
  background-size: cover;
  width: 100%;
  height: 120px;
  position: absolute;
  top: 0;
  left: 0;

  ${MediaQuery.BiggerThanSmall} {
    height: 240px;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 100vw;
  position: relative;

  ${MediaQuery.BiggerThanSmall} {
    position: initial;
    min-width: initial;
    max-width: 800px;
  }

  ${MediaQuery.BiggerThanMedium} {
    margin-top: 90px;
  }
`;

const OrgBannerStyles = {
  Logo,
  StatusLabel,
  IconSvg,
  LoyaltyContainer,
  ModalButtonsWrapper,
  ButtonsAndStatusContainer,
  Name,
  Description,
  ContentColumn,
  Content,
  Background,
  Container,
};

export default OrgBannerStyles;
